/**
 * Get an item randomly in an array.
 */
export const randomInArray = <T>(col: T[]): T =>
    col[Math.floor(Math.random() * col.length)];
